module.exports = __webpack_public_path__ + "img/gate.e44e0810.jpg";